<template>
  <component :is="currentShape" ref="shapeRef" v-bind="shapeProps" />
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits, defineExpose } from 'vue'
import DesignerShapeRectangle from './shapes/DesignerShapeRectangle.vue'
import DesignerShapeCircle from './shapes/DesignerShapeCircle.vue'
import DesignerShapeTriangle from './shapes/DesignerShapeTriangle.vue'

const props = defineProps({
  type: { type: String, required: true },
  width: Number,
  height: Number,
  radiusX: Number,
  radiusY: Number,
  positionX: Number,
  positionY: Number,
  zIndex: Number,
  bleedOffset: Number,
  svg: { type: String, default: '' },
})

const emit = defineEmits([
  'update:width',
  'update:height',
  'update:radiusX',
  'update:radiusY',
  'update:positionX',
  'update:positionY',
  // dôležité pre v-model:svg
  'update:svg',
])

// podporuj aj "rectangle" aj "square" pre istotu
const shapeMap: Record<string, any> = {
  rectangle: DesignerShapeRectangle,
  square: DesignerShapeRectangle,
  circle: DesignerShapeCircle,
  triangle: DesignerShapeTriangle,
}

const currentShape = computed(() => shapeMap[props.type] || DesignerShapeRectangle)

const shapeProps = computed(() => ({
  ...props,
  'onUpdate:width':     (v: number) => emit('update:width', v),
  'onUpdate:height':    (v: number) => emit('update:height', v),
  'onUpdate:radiusX':   (v: number) => emit('update:radiusX', v),
  'onUpdate:radiusY':   (v: number) => emit('update:radiusY', v),
  'onUpdate:positionX': (v: number) => emit('update:positionX', v),
  'onUpdate:positionY': (v: number) => emit('update:positionY', v),
  'onUpdate:svg':       (v: string)  => emit('update:svg', v),
}))

const shapeRef = ref()
function getSvg() {
  return shapeRef.value?.getSvg?.()
}

defineExpose({ getSvg })
</script>
